import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
  Divider,
} from "@mui/material";
import { useFormikContext, FieldArray } from "formik";
import React, { useEffect } from "react";

const publishMethods = ["manual", "automatic"];
const outcomeOptions = ["Rating", "Comments", "Appraiser"];

const Step5PublishConfiguration = () => {
  const { values, setFieldValue } = useFormikContext();

  const handlePublishMethodChange = (method) => () => {
    setFieldValue("publishConfiguration.publishMethod", method);
  };

  const handleOutcomeChange = (event) => {
    const {
      target: { value },
    } = event;
    setFieldValue(
      "publishConfiguration.outcomesShared",
      typeof value === "string" ? value.split(",") : value
    );
  };

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Typography variant="h6">Publish Method</Typography>
      <Divider />
      {publishMethods.map((method) => (
        <FormControlLabel
          key={method}
          control={
            <Checkbox
              checked={values.publishConfiguration.publishMethod === method}
              onChange={handlePublishMethodChange(method)}
            />
          }
          label={method.charAt(0).toUpperCase() + method.slice(1)}
        />
      ))}

      <Typography variant="h6">Outcomes Shared</Typography>
      <Divider />
      <FormControl fullWidth size="small">
        <InputLabel id="outcomes-shared-label">Select Outcomes</InputLabel>
        <Select
          labelId="outcomes-shared-label"
          multiple
          value={values.publishConfiguration.outcomesShared}
          onChange={handleOutcomeChange}
          input={<OutlinedInput label="Select Outcomes" />}
          renderValue={(selected) => selected.join(", ")}
        >
          {outcomeOptions.map((option) => (
            <MenuItem key={option} value={option}>
              <Checkbox
                checked={values.publishConfiguration.outcomesShared.includes(
                  option
                )}
              />
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Typography variant="h6">Employee Feedback</Typography>
      <Divider />
      <FormControlLabel
        control={
          <Checkbox
            checked={values.publishConfiguration.allowEmployeeFeedback}
            onChange={(e) =>
              setFieldValue(
                "publishConfiguration.allowEmployeeFeedback",
                e.target.checked
              )
            }
          />
        }
        label="Allow Employee Feedback"
      />
    </Box>
  );
};

export default Step5PublishConfiguration;
